/**
 * The collection of i18n strings.
 *
 * @since 0.1.0
 */
export const I18N = {
  copy        : 'Copy',
  cut         : 'Cut',
  paste       : 'Paste',
  selectAll   : 'Select All',
  close       : 'Close',
  confirm     : 'OK',
  activate    : 'Activate',
  notice      : 'Notice',
  cancel      : 'Cancel',
  failedToCopy: 'Can not copy on your environment.',
  scrollbar   : 'Drag to Scroll',
  inputLabel  : 'Edit contents',
  location    : 'Line: %s, Column: %s',
};
